/**
 * @module rect
 * @private
 * @since 2.0.0
 */

/**
 * @typedef RectObject
 * @type     {Object}
 * @property {number} left   Y of left end
 * @property {number} top    X of top end
 * @property {number} right  Y of right end
 * @property {number} bottom X of bottom end
 * @property {number} width
 * @property {number} height
 */

/**
 * Get size object for relevant DOM element
 * @param  {DOMElement|Window|Document} element
 * @return {RectObject}
 */
export function rect(element) {
    if (element instanceof Window || element instanceof HTMLDocument) {
        return {
            left: 0,
            top: 0,
            right: window.innerWidth,
            bottom: window.innerHeight,
            width: window.innerWidth,
            height: window.innerHeight
        };
    }

    const {
        left,
        top,
        right,
        bottom,
        width,
        height
    } = element.getBoundingClientRect();

    return {
        left,
        top,
        right,
        bottom,
        width,
        height
    };
}
